<template>
    <v-container>
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-block py-2 text-center font-weight-bold primary white--text"
                                  style="word-break: normal">REPORTE DE MOVIMIENTOS
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12">
                <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
                    <v-card>
                        <v-card-text>
                            <v-tabs v-model="tab" grow>
                                <v-tab @click="format('-')">Reportar Salidas</v-tab>
                                <v-tab @click="format('+')">Reportar Entradas</v-tab>
                            </v-tabs>
                            <v-divider/>
                            <v-tabs-items v-model="tab">
                                <v-tab-item>
                                    <v-card flat v-if="tp === '-'">
                                        <v-progress-linear indeterminate fixed v-if="loading" style="top:0"/>
                                        <v-card-text>
                                            <v-row justify="center">
                                                <v-col cols="12" sm="6" md="4" class="text-center">
                                                    <v-select
                                                        :label="labels.country"
                                                        :items="countries"
                                                        name="country"
                                                        v-model="form.country1"
                                                        :disabled="loading"
                                                        :error-messages="errors.country1"
                                                        :rules="[rules.required('country')]"
                                                        @input="clearErrors('country1')"
                                                        prepend-inner-icon="mdi-map-marker"
                                                        item-text="name"
                                                        item-value="code"
                                                        hide-details
                                                        filled>
                                                        <template v-slot:selection="{ item }">
                                                            <v-flex>
                                                                <v-avatar size="28px" class="mr-2">
                                                                    <img :src="'/img/country/' + item.code + '.png'" :alt="item.name.toLowerCase()" />
                                                                </v-avatar>{{ item.name }}
                                                            </v-flex>
                                                        </template>
                                                        <template v-slot:item="{ item }">
                                                            <v-list-item-avatar>
                                                                <img :src="'/img/country/' + item.code + '.png'" :alt="item.name.toLowerCase()" />
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title v-html="item.name"/>
                                                            </v-list-item-content>
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-currency-field
                                                        :label="labels.value"
                                                        v-model="form.value1"
                                                        name="value"
                                                        :error-messages="errors.value1"
                                                        :rules="[rules.required('value'), rules.minus('value', form.value1, 0.01, 'El')]"
                                                        :disabled="loading"
                                                        @input="clearErrors('value1')"
                                                        prepend-inner-icon="mdi-currency-usd"
                                                        v-bind="currency_config"
                                                        filled/>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="center">
                                                <v-col cols="12" md="8">
                                                    <v-autocomplete
                                                        :label="labels.account"
                                                        :items="accounts"
                                                        name="account"
                                                        v-model="form.account1"
                                                        :error-messages="errors.account1"
                                                        :disabled="loading"
                                                        :rules="[rules.req('account')]"
                                                        @select="clearErrors('account1')"
                                                        prepend-inner-icon="mdi-wallet"
                                                        item-text="text"
                                                        item-value="id"
                                                        filled>
                                                        <template v-slot:selection="{ item }">
                                                            <v-flex class='ml-1'><b>{{ item.code }}</b> - {{ item.alias }} - {{ item.currency }}</v-flex>
                                                        </template>
                                                        <template v-slot:item="{ item }">
                                                            <v-list-item-content>
                                                                <v-list-item-title v-html="'<b>' + item.code + '</b> - ' + item.alias + ' - ' + item.currency"/>
                                                                <v-list-item-subtitle v-html="'<b>' + item.bank_name+'</b>'"/>
                                                            </v-list-item-content>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="center">
                                                <v-col cols="12" md="8">
                                                    <v-textarea
                                                        :label="labels.detail"
                                                        v-model="form.detail1"
                                                        name="detail"
                                                        counter="255"
                                                        :error-messages="errors.detail1"
                                                        :disabled="loading"
                                                        :rules="[rules.required('detail'), rules.min('detail', 6, 'El'), rules.max('detail', 255, 'El')]"
                                                        prepend-inner-icon="mdi-clipboard-text"
                                                        @input="clearErrors('detail1')"
                                                        no-resize
                                                        rows="3"
                                                        filled/>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="center">
                                                <v-col cols="12" sm="6" md="5">
                                                    <v-btn type="submit" block :loading="loading" color="success" :disabled="loading || !valid">
                                                        <v-icon>mdi-circle-multiple-outline</v-icon><span>&nbsp;&nbsp;Registrar Egreso</span>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item>
                                    <v-card flat v-if="tp === '+'">
                                        <v-progress-linear indeterminate fixed v-if="loading" style="top:0"/>
                                        <v-card-text>
                                            <v-row justify="center">
                                                <v-col cols="12" sm="6" md="4" class="text-center">
                                                    <v-select
                                                        :label="labels.country"
                                                        :items="countries"
                                                        name="country"
                                                        v-model="form.country2"
                                                        :disabled="loading"
                                                        :error-messages="errors.country2"
                                                        :rules="[rules.required('country')]"
                                                        @input="clearErrors('country2')"
                                                        prepend-inner-icon="mdi-map-marker"
                                                        item-text="name"
                                                        item-value="code"
                                                        hide-details
                                                        filled>
                                                        <template v-slot:selection="{ item }">
                                                            <v-flex>
                                                                <v-avatar size="28px" class="mr-2">
                                                                    <img :src="'/img/country/' + item.code + '.png'" :alt="item.name.toLowerCase()" />
                                                                </v-avatar>{{ item.name }}
                                                            </v-flex>
                                                        </template>
                                                        <template v-slot:item="{ item }">
                                                            <v-list-item-avatar>
                                                                <img :src="'/img/country/' + item.code + '.png'" :alt="item.name.toLowerCase()" />
                                                            </v-list-item-avatar>
                                                            <v-list-item-content>
                                                                <v-list-item-title v-html="item.name"/>
                                                            </v-list-item-content>
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="4">
                                                    <v-currency-field
                                                        :label="labels.value"
                                                        v-model="form.value2"
                                                        name="value"
                                                        :error-messages="errors.value2"
                                                        :rules="[rules.required('value'), rules.minus('value', form.value2, 0.01, 'El')]"
                                                        :disabled="loading"
                                                        @input="clearErrors('value2')"
                                                        prepend-inner-icon="mdi-currency-usd"
                                                        v-bind="currency_config"
                                                        filled/>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="center">
                                                <v-col cols="12" md="8">
                                                    <v-autocomplete
                                                        :label="labels.account"
                                                        :items="accounts"
                                                        name="account"
                                                        v-model="form.account2"
                                                        :error-messages="errors.account2"
                                                        :disabled="loading"
                                                        :rules="[rules.req('account')]"
                                                        @select="clearErrors('account2')"
                                                        prepend-inner-icon="mdi-wallet"
                                                        item-text="name"
                                                        item-value="id"
                                                        filled>
                                                        <template v-slot:selection="{ item }">
                                                            <v-flex class='ml-1'><b>{{ item.code }}</b> - {{ item.alias }} - {{ item.currency }}</v-flex>
                                                        </template>
                                                        <template v-slot:item="{ item }">
                                                            <v-list-item-content>
                                                                <v-list-item-title v-html="'<b>' + item.code + '</b> - ' + item.alias + ' - ' + item.currency"/>
                                                                <v-list-item-subtitle v-html="'<b>' + item.bank_name + '</b>'"/>
                                                            </v-list-item-content>
                                                        </template>
                                                    </v-autocomplete>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="center">
                                                <v-col cols="12" md="8">
                                                    <v-textarea
                                                        :label="labels.detail"
                                                        v-model="form.detail2"
                                                        name="detail"
                                                        counter="255"
                                                        :error-messages="errors.detail2"
                                                        :disabled="loading"
                                                        :rules="[rules.required('detail'), rules.min('detail', 6, 'El'), rules.max('detail', 255, 'El')]"
                                                        prepend-inner-icon="mdi-clipboard-text"
                                                        @input="clearErrors('detail2')"
                                                        no-resize
                                                        rows="3"
                                                        filled/>
                                                </v-col>
                                            </v-row>
                                            <v-row justify="center">
                                                <v-col cols="12" sm="6" md="5">
                                                    <v-btn type="submit" block :loading="loading" color="success" :disabled="loading || !valid">
                                                        <v-icon>mdi-circle-multiple-outline</v-icon><span>&nbsp;&nbsp;Registrar Ingreso</span>
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import axios from 'axios';
    import Form from '../../../helpers/form';

    export default {
        name: "AcInOut",
        mixins: [ Form ],
        props: [ 'user' ],
        data: () => ({
            tab: null,
            loading: false,
            countries: [
                { name: 'Brasil', code: 'BRA' },
                { name: 'Chile', code: 'CHL' },
                { name: 'Colombia', code: 'COL' },
                { name: 'Ecuador', code: 'ECU' },
                { name: 'Estados Unidos', code: 'USA' },
                { name: 'México', code: 'MEX' },
                { name: 'Panamá', code: 'PAN' },
                { name: 'Perú', code: 'PER' },
                { name: 'Venezuela', code: 'VEN' },
                { name: 'Todos', code: '000' }
            ],
            accounts: [],
            labels: {
                country: 'País',
                detail: 'Detalle',
                account: 'Cuenta Bancaria',
                value: 'Valor'
            },
            form: {
                country1: null,
                country2: null,
                detail1: null,
                detail2: null,
                account1: null,
                account2: null,
                value1: null,
                value2: null
            },
            currency_config: {
                locale: 'en-US',
                decimalLength: 2,
                autoDecimalMode: false,
                min: null,
                max: null,
                defaultValue: 0,
                valueAsInteger: false,
                allowNegative: false
            },
            tp: '-'
        }),
        watch: {
            'form.country1'() {
                if (this.form.country1)
                    this.getAccounts(this.form.country1);
            },
            'form.country2'() {
                if (this.form.country2)
                    this.getAccounts(this.form.country2);
            }
        },
        methods: {
            getAccounts(c) {
                this.loading = true;
                axios.get('/api/transfers/t/accounts/' + c).then((res) => {
                    this.accounts = res.data.accounts;
                }).catch(err => {
                    this.handleErrors(err.response.data.errors);
                }).then(() => {
                    this.loading = false;
                });
            },
            format(id) {
                this.tp = id;
            },
            cleanData(tp) {
                if (tp === '-') {
                    this.form.country1 = null;
                    this.form.detail1 = null;
                    this.form.account1 = null;
                    this.form.value1 = null;
                } else if (tp === '+') {
                    this.form.country2 = null;
                    this.form.detail2 = null;
                    this.form.account2 = null;
                    this.form.value2 = null;
                }
                this.$refs.form.reset();
            },
            submit() {
                if (this.$refs.form.validate()) {
                    this.loading = true;

                    let tp = this.tp;
                    let formData = new FormData();

                    formData.append('tp', tp);
                    formData.append('country', tp === '-' ? this.form.country1 : this.form.country2);
                    formData.append('details', tp === '-' ? this.form.detail1 : this.form.detail2);
                    formData.append('account', tp === '-' ? this.form.account1 : this.form.account2);
                    formData.append('value', tp === '-' ? this.form.value1 : this.form.value2);

                    axios.post('/api/movements/in-out', formData).then(res => {
                        if (res.data.v === 'success') {
                            this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                            this.cleanData(tp);
                        } else {
                            this.$toast.warning(res.data.status, {
                                timeout: 8000,
                                icon: 'mdi-information',
                                dismissable: false,
                                showClose: true
                            });
                        }
                    }).catch(err => {
                        this.handleErrors(err.response.data.errors);
                    }).then(() => {
                        this.loading = false;
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
